<!-- nav secciones -->
<router-outlet></router-outlet>